import { canv } from '@/canv/global.js'

export class propertyEvent {

    constructor() {
    }

    init(UID, fixType, state) {
        this.event = {
            "type": "property",
            "UID": UID,
            "fixType": fixType,
            "state": state
        };
    }

    execEvent() {
        var entity = canv.canvasController.FindByUID(this.event["UID"]);
        if (entity == null) return;

        entity.loadState(this.event["state"], this.event["fixType"]);
    }

    checkEvent() {
        var entity = canv.canvasController.FindByUID(this.event["UID"]);
        if (entity == null) {
            return false;
        }

        return entity.checkEvent(this.event["state"], this.event["fixType"]);
    }

    getEvent() {
        return this.event;
    }

    loadEvent(event) {
        this.event = event;
    }

    getTwin() {
        let enitity = canv.canvasController.FindByUID(this.event["UID"]);
        let twinState = enitity.getState(this.event["fixType"], this.event["state"]);
        let twin = new propertyEvent();
        twin.init(this.event["UID"], this.event["fixType"], twinState);

        return twin;
    }





    event = {};


}
